module.exports = __webpack_public_path__ + "static/img/介绍_4.aeac97a0.jpg";